export default {
  auto: 'Auto',
  signals: 'Signals',
  axes: 'Axes',
  axesHeader: {
    displayName: 'Axis label',
    chartScaleType: 'Axis type',
    position: 'Axis position',
    limitMin: 'Min limit',
    limitMax: 'Max limit',
    defaultUnitOfMeasure: 'Unit of measure',
    signalCount: 'Signal count',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Delete axis?',
    message: 'The {count} signals of this axis are removed from the chart as well.',
  },
};
